export const initialise = () => {
    if (!document.body.classList.contains('page-job-details')) return
    const stickyApply = document.querySelector<HTMLElement>('.component-sticky-apply')
    if (!stickyApply) return

    createStickyApplyHeading(stickyApply)
    showStickyApply(stickyApply)
}

export const createStickyApplyHeading = (stickyApply: HTMLElement) => {
    const jobTitle = document.querySelector<HTMLElement>('.title-widget .header__text')
    const stickyHeading = stickyApply.querySelector<HTMLElement>('.component-sticky-apply__heading')

    if (!jobTitle || !stickyHeading) return

    stickyHeading.innerText = jobTitle.innerText
}

export const showStickyApply = (stickyApply: HTMLElement) => {
    const hero = document.querySelector<HTMLElement>('.page-job-details__hero')
    const footer = document.querySelector<HTMLElement>('footer.component-footer')
    if (!hero || !footer) return

    let isHeroVisible = true
    let isFooterVisible = false

    const updateStickyApply = () => {
        const shouldShow = !isHeroVisible && !isFooterVisible
        if (shouldShow) {
            stickyApply.classList.add('component-sticky-apply--visible')
        } else {
            stickyApply.classList.remove('component-sticky-apply--visible')
        }
    }

    const observerFooter = new IntersectionObserver(
        ([entry]) => {
            isFooterVisible = entry.isIntersecting
            updateStickyApply()
        }, { threshold: 0 }
    )
    
    const observerHero = new IntersectionObserver(
        ([entry]) => {
            isHeroVisible = entry.isIntersecting
            updateStickyApply()
        }, { threshold: 0 }
    )

    observerFooter.observe(footer)
    observerHero.observe(hero)
}
